import React, { Fragment, useEffect, useRef } from 'react';

type Props = {
  children?: React.ReactNode;
};

/*
This is necessary when the previous state needs to persist for animation purposes
*/
export function MemoizeLastNonNull({ children }: Props): React.ReactElement {
  const nonNullChildren = useRef<React.ReactNode>();

  useEffect(() => {
    if (children != null) {
      nonNullChildren.current = children;
    }
  });

  return <Fragment>{children || nonNullChildren.current}</Fragment>;
}
